// ─── Shared constants and pure helpers for the Referrals view ────────────────

export { PAGE_SIZES } from '../shared.constants.js';

// ── Filter options ────────────────────────────────────────────────────────────

// Mirrors STATUSES in controller/referralController.js exactly.
export const REWARD_STATUSES = [
  { value: 'pending', label: 'Pending' },
  { value: 'credited', label: 'Credited' },
];

export const FILTER_DEFAULTS = {
  status: '',
  dateFrom: '',
  dateTo: '',
};

export function countActiveFilters(f) {
  let count = 0;
  if (f.status !== '') count++;
  if (f.dateFrom !== '' || f.dateTo !== '') count++;
  return count;
}

// ── Column definitions (keys double as the server-side sort keys) ─────────────

export const COLS = [
  { key: 'referrer_name', label: 'Referrer', sortable: true },
  { key: 'referrer_account_name', label: 'Referrer account', sortable: false },
  { key: 'referee_name', label: 'Referred user', sortable: true },
  { key: 'referee_subscription_status', label: 'Referred status', sortable: false },
  { key: 'referral_date', label: 'Referral date', sortable: true },
  { key: 'referral_credited_at', label: 'Reward', sortable: true },
];

export const DEFAULT_SORT = { key: 'referral_date', dir: 'desc' };

// Stripe subscription_status → pill tone. Anything unknown renders neutral.
export const SUBSCRIPTION_STATUS_TONE = {
  active: 'good',
  trialing: 'good',
  past_due: 'warn',
  incomplete: 'warn',
  unpaid: 'bad',
  canceled: 'bad',
  deleted: 'bad',
};

export function subscriptionStatusLabel(status) {
  if (!status) return STRINGS.noSubscription;
  return status.replace(/_/g, ' ');
}

// ── UI strings ────────────────────────────────────────────────────────────────

export const STRINGS = {
  // Page
  pageTitle: 'Referrals',
  pageSubtitle: 'Who referred whom, when, and whether the referrer has been rewarded',

  // Search / table
  searchPlaceholder: 'Search by referrer or referred user...',
  emptyMessage: 'No referrals found.',
  unknownUser: 'Unknown user',
  noAccount: '—',
  noSubscription: 'No subscription',

  // Reward cell
  rewardPending: 'Pending',
  rewardCredited: 'Credited',

  // Filters panel
  filtersBtn: 'Filters',
  clearAll: 'Clear all',
  apply: 'Apply',
  rewardSectionLabel: 'Reward',
  dateSectionLabel: 'Referral date',
  dateFrom: 'From',
  dateTo: 'To',
};
